/**
 * The ONE rule for which comments are visible given the user's reviewer
 * toggles. It existed as two hand-copied filters (page.jsx feeding the rail,
 * ReviewerSettings feeding the room) and they drifted: Chat-attributed notes
 * were added to one and not the other, so the room counted 8 while the margin
 * showed none. One function, imported by both, so the rule cannot fork again.
 *
 * Visible = unattributed (agent_name null), OR from the conversational agent
 * ("Chat" — governed by the client-side Chat pseudo-agent toggle below), OR
 * from a reviewer currently enabled. No reviewer list loaded ⇒ reviewer notes
 * all show (never hide notes on a fetch gap); the Chat toggle still applies —
 * it doesn't come from that fetch.
 */
export function filterVisibleComments(comments, reviewAgents, { chatEnabled = true } = {}) {
  const noRoster = !Array.isArray(reviewAgents) || reviewAgents.length === 0;
  const enabledNames = new Set();
  if (!noRoster) {
    for (const tier of reviewAgents) {
      for (const agent of tier.agents || []) {
        if (agent.is_enabled) enabledNames.add(agent.name);
      }
    }
  }
  return comments.filter((c) => {
    if (c.agent_name === "Chat") return chatEnabled;
    if (!c.agent_name || noRoster) return true;
    return enabledNames.has(c.agent_name);
  });
}

// The Chat pseudo-agent: chat's margin notes toggle like a reviewer, but
// "Chat" is not a server-side agent — the toggle lives client-side.
const CHAT_AGENT_KEY = "qk-chat-agent-enabled";

export function loadChatAgentEnabled() {
  if (typeof window === "undefined") return true;
  return window.localStorage.getItem(CHAT_AGENT_KEY) !== "0";
}

export function saveChatAgentEnabled(enabled) {
  if (typeof window === "undefined") return;
  window.localStorage.setItem(CHAT_AGENT_KEY, enabled ? "1" : "0");
}
